import { useCallback, useState } from 'react'

/**
 * Drobne preferencje interfejsu (np. tryb rzeczywistego kosztu) trzymamy
 * w `localStorage` — to nie są dane firmowe, a użytkownik oczekuje, że
 * przełącznik zostanie tam, gdzie go zostawił.
 */
export function useUstawienieLogiczne(klucz: string, domyslne: boolean): [boolean, (nowe: boolean) => void] {
  const [wartosc, ustawWartosc] = useState<boolean>(() => {
    try {
      const zapisane = window.localStorage.getItem(klucz)
      return zapisane === null ? domyslne : zapisane === 'tak'
    } catch {
      return domyslne
    }
  })

  const ustaw = useCallback(
    (nowe: boolean) => {
      ustawWartosc(nowe)
      try {
        window.localStorage.setItem(klucz, nowe ? 'tak' : 'nie')
      } catch {
        // Tryb prywatny może blokować zapis — preferencja zostanie na czas sesji.
      }
    },
    [klucz],
  )

  return [wartosc, ustaw]
}
